export const RECLASSIFY_COPY = {
  title: '重新分類',
  intent: '意圖',
  intentPlaceholder: '請選擇意圖',
  inDomain: '業務範圍內',
  folder: '資料夾',
  save: '儲存',
  saving: '儲存中…',
  cancel: '取消',
  notSpam: '不是垃圾',
  unmute: '移回收件匣',
  moving: '移動中…',
  correctionNote: '修正會連同原始分類一起記錄，用來衡量分類準確率。',
} as const
